import { mapGetters } from 'vuex';

export default {
  props: ['landlordId'],

  computed: {
    ...mapGetters(['getLandlordProfileMeta']),

    landlord() {
      return this.getLandlordProfileMeta(this.landlordId);
    },

    landlordMeta() {
      return this.landlord ? this.landlord.meta : null;
    },

    landlordAsOrganization() {
      return this.landlordMeta ? this.landlordMeta.organization : null;
    },

    isLandlordProfessional() {
      return !!this.landlord && this.landlord.type === 'professional';
    },

    isLandlordRegistered() {
      return this.landlordAsOrganization ? this.landlordAsOrganization.isRegisteredBusiness : false;
    },

    isLandlordRegisteredForVAT() {
      return this.landlordAsOrganization ? this.landlordAsOrganization.isRegisteredForVAT : false;
    },

    canLandlordChargeVat() {
      return this.isLandlordProfessional && this.isLandlordRegisteredForVAT;
    },

    MVAOptions() {
      if (this.canLandlordChargeVat) {
        return this.unrestrictedMVAOptions;
      }
      return this.restrictedMVAOptions;
    },

    restrictedMVAOptions() {
      return [{ name: '0%', value: 0 }];
    },

    unrestrictedMVAOptions() {
      return [
        { name: '0%', value: 0 },
        { name: '25%', value: 25 },
      ];
    },
  },

  methods: {
    MVAOptionsForRow(row) {
      if (this.canLandlordChargeVat || row.unrestrictedVAT) {
        return this.unrestrictedMVAOptions;
      }
      return this.restrictedMVAOptions;
    },
    MVAOptionForRow(row) {
      return [{ name: `${row.vat}%`, value: row.vat }];
    },
  },
};
